import { Dialog } from '@mui/material';
import { CreateIndividualForm } from 'components';
import React, { ReactElement } from 'react';
import { Individual } from 'utils';
import { TransitionProps } from '@mui/material/transitions';

export interface CreateIndividualModalProps {
    onIndividualCreated: (individual: Individual) => void;
    onIndividualCreatedFailed: (message: string) => void;
    open?: boolean;
    onClose?: Function;
}

// No-op transition that doesn't call reflow, avoiding scrollTop errors
const NoTransition = React.forwardRef(function NoTransition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    const { children, in: inProp } = props;
    return (
        <div ref={ref as React.Ref<HTMLDivElement>} style={{ display: inProp ? 'block' : 'none' }}>
            {children}
        </div>
    );
});

export default function CreateIndividualModal({
    onIndividualCreated,
    onIndividualCreatedFailed,
    open = true,
    onClose,
}: CreateIndividualModalProps): ReactElement {
    const handleIndividualCreated = (individual: Individual) => {
        onIndividualCreated(individual);
    };
    const handleIndividualCreationFailed = (message: string) => {
        onIndividualCreatedFailed(message);
    };
    return (
        <Dialog open={open} TransitionComponent={NoTransition}>
            <CreateIndividualForm
                onIndividualCreationFailed={handleIndividualCreationFailed}
                onIndividualCreated={handleIndividualCreated}
                onClose={onClose}
            />
        </Dialog>
    );
}
